import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  TextField,
  Box,
  Button,
  useTheme,
  FormControl,
} from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import { useIntl } from 'umi';
import DataTableNativeML from '@/components/DataTableNativeML';
import request from '@/utils/request';
import DateRangePickerML from '@/components/DateRangePickerML';
import TicketModalStyled from './TicketModalStyled';

export default (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  const [isRefresh, setIsRefresh] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const {
    setOpen = () => {},
    onConfirm,
    couponList,
    showType,
    setTicketList,
  } = props;

  const [pageData, setPageData] = useState({
    pageSize: 8,
    pageNum: 1,
  });

  const couponIdList = useMemo(() => {
    return couponList?.map((i) =>
      showType !== 'DESIGNATED_SERIES' ? i.id : i.proNo,
    );
  }, [couponList]);

  const [couponTitle, setCouponTitle] = useState('');
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const fetchCouponList = useCallback(() => {
    request('/product/queryPage', {
      method: 'POST',
      data: {
        pageNum: pageData.pageNum,
        pageSize: pageData.pageSize,
        proName: isSearch ? couponTitle : null,
        featureDate: date?.startDate ? date?.startDate : null,
        totalDate: date?.endDate ? date?.endDate : null,
        showType: showType === 'DESIGNATED_SERIES' ? 1 : 0,
      },
    }).then((res) => {
      setCpList(res.data.data);
      setTotal(res.data.total);
      setPages(res.data.pages);
    });
  }, [pageData, isRefresh]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);

  const [cpList, setCpList] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);
  const columns = [
    {
      type: 'checkbox',
      width: 80,
      onChange: (a, b, c) => {
        const data = [...couponList, ...c];
        let chooseArr = [];
        const key = showType !== 'DESIGNATED_SERIES' ? 'id' : 'proNo';
        data.forEach((item) => {
          const findItem = chooseArr.some((it) => item[key] === it[key]);
          if (a.includes(item[key]) && !findItem) {
            chooseArr.push(item);
          }
        });
        setTicketList(chooseArr);
      },
    },
    ...(showType !== 'DESIGNATED_SERIES'
      ? [
          {
            title: '剧目编码',
            align: 'left',
            id: 'proNo',
            key: 'proNo',
            width: 100,
          },
          {
            title: '剧目名称',
            align: 'left',
            id: 'proName',
            key: 'proName',
            width: 225,
          },
          {
            title: '场次编码',
            align: 'left',
            id: 'featureNo',
            key: 'featureNo',
            width: 225,
          },
          {
            title: '场次时间',
            align: 'left',
            id: 'featureTime',
            key: 'featureTime',
            width: 220,
            render: (row) => {
              return `${row.featureDate} ${row.featureTime}`;
            },
          },
          {
            title: '标准价',
            align: 'left',
            id: 'price',
            key: 'price',
            width: 120,
          },
        ]
      : [
          {
            title: '剧目编码',
            align: 'left',
            id: 'proNo',
            key: 'proNo',
            width: 100,
          },
          {
            title: '剧目名称',
            align: 'left',
            id: 'proName',
            key: 'proName',
            width: 225,
          },
          {
            title: '演出时间',
            align: 'left',
            id: 'featureTime',
            key: 'featureTime',
            width: 220,
            render: (row) => {
              return `${row.proStartDate || ''} ${row.proEndDate || ''}`;
            },
          },
        ]),
  ];

  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = () => {
    onConfirm(couponList);
    setOpen(false);
  };

  const footContent = (
    <div className="modal-btn-wrap">
      <Button onClick={handleClose} variant="contained" color="secondary">
        {formatMessage({ id: 'comm.action.btn.08' })}
      </Button>
      <Button
        variant="contained"
        type="submit"
        className="btnSubmit button"
        onClick={onSubmit}
      >
        {formatMessage({ id: 'comm.action.btn.07' })}
      </Button>
    </div>
  );
  const handleRestClick = () => {
    setIsReset(true);
    setDate({
      startDate: null,
      endDate: null,
    });
    setIsSearch(false);
    setCouponTitle('');
    setPageData({ ...pageData, pageNum: 1 });
    setIsRefresh(isRefresh + 1);
  };
  return (
    <TicketModalStyled theme={theme}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 32px',
        }}
      >
        <Box className="coupon-name-wrap">
          <Box sx={{ color: '#212121', fontSize: '18px', fontWeight: '600' }}>
            {showType === 'DESIGNATED_SERIES' ? '选择剧目' : '选择票档'}
          </Box>
          <TextField
            className="coupon-name"
            variant="standard"
            onChange={(e) => {
              setCouponTitle(e.target.value);
              setIsSearch(false);
            }}
            value={couponTitle}
            label="剧目名称"
            placeholder="请输入剧目名称"
          />
          <FormControl
            variant="standard"
            sx={{
              visibility:
                showType === 'DESIGNATED_SERIES' ? 'hidden' : 'visible',
            }}
          >
            <DateRangePickerML
              label="场次时间"
              startText="场次开始时间"
              endText="场次结束时间"
              defaultStartDate={null}
              defaultEndDate={null}
              onChange={(data) => {
                setIsReset(false);
                setDate({
                  startDate: data.startDate,
                  endDate: data.endDate,
                });
              }}
              // name="custom-form-submit-name"
              isReset={isReset}
            />
          </FormControl>
        </Box>
        <Box
          className="button-group"
          sx={{
            display: 'flex',
            gap: '6px',
            flexShrink: 0,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            className="reset"
            onClick={handleRestClick}
            startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
          >
            {formatMessage({ id: 'comm.action.btn.06' })}
          </Button>

          <Button
            variant="contained"
            className="search"
            startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            onClick={() => {
              setPageData({ ...pageData, pageNum: 1 });
              setIsRefresh(isRefresh + 1);
              setIsSearch(true);
            }}
          >
            {formatMessage({ id: 'comm.action.btn.01' })}
          </Button>
        </Box>
      </Box>
      <div className="coupon-list">
        <DataTableNativeML
          columns={columns}
          changePage={changePage}
          page={pageData}
          data={cpList}
          total={total}
          devicesMinWidth="auto"
          chooseIds={couponIdList}
          paging={true}
          columnKey={showType !== 'DESIGNATED_SERIES' ? 'id' : 'proNo'}
          FootContent={footContent}
          initP={true}
          hasNext={pageData.pageNum < pages}
          showPagingData={{ status: true, marginTop: '24px' }}
          showPageColor={true}
          pages={pages}
          np={true}
        ></DataTableNativeML>
      </div>
    </TicketModalStyled>
  );
};
